import {
    SHOW_NOTIFICATION,
    HIDE_NOTIFICATION,
} from 'store/actions/notificationActions';
import { LOCATION_CHANGE } from 'connected-react-router';
import find from 'lodash-es/find';
import { PATH_FOR_LOGIN } from 'util/constants';

const initialState = [];

let previousPathname = '';

export default (previousState = initialState, { type, payload, newNotification, notificationKey }) => {
    switch (type) {

        case LOCATION_CHANGE:
            if( previousPathname !== payload.location.pathname ) {
                const previous = previousPathname.split("/");
                const now = payload.location.pathname.split("/");
                previousPathname = payload.location.pathname;
                if( previous[1] !== now[1] && payload.location.pathname !== PATH_FOR_LOGIN ) { // 로그아웃 Noti를 유지하기 위해 로그인페이지는 제외
                    return initialState;
                }
            }
            return previousState;

        case SHOW_NOTIFICATION:
            // 동일한 category의 Noti가 이미 있는 경우 추가 안 함
            if( newNotification.category ) {
                const sameNotification = find(previousState, ["category", newNotification.category]);
                if( sameNotification ) {
                    return previousState;
                }
            }
            return [
                ...previousState,
                newNotification
            ];

        case HIDE_NOTIFICATION:
            if(!notificationKey) { // notificationKey 없이 호출한 경우 이전 알림 모두 삭제되게 수정 
                return initialState;
            }
            return previousState.filter(notification => notification.key !== notificationKey);

        default:
            return previousState;
    }
};